import { render } from "./EnrolleeAdd.vue?vue&type=template&id=33466c81&scoped=true"
import script from "./EnrolleeAdd.vue?vue&type=script&lang=js"
export * from "./EnrolleeAdd.vue?vue&type=script&lang=js"

import "./EnrolleeAdd.vue?vue&type=style&index=0&id=33466c81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33466c81"]])

export default __exports__